import { Component, computed, inject, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { of } from 'rxjs';

import { rxResourceFixed, CurrencyService, SkeletonComponent } from '@zayan-erp/shared';
import { DsmApsService } from '../../services/dsm-aps.service';

@Component({
  selector: 'dsm-aps-buyer-selection',
  templateUrl: './dsm-aps-buyer-selection.component.html',
  imports: [CommonModule, SkeletonComponent]
})
export class DsmApsBuyerSelectionComponent {
  dealId = input.required<string>();

  #service = inject(DsmApsService);
  #currencyService = inject(CurrencyService);

  selectionsResource = rxResourceFixed({
    params: () => ({ dealId: this.dealId() }),
    defaultValue: null,
    stream: ({ params }) => {
      if (!params.dealId) return of(null);
      return this.#service.getBuyerSelections(params.dealId, false);
    }
  });

  selections = computed(() => this.selectionsResource.value());
  isLoading = computed(() => this.selectionsResource.isLoading());

  fmt(value: number | null | undefined): string {
    return this.#currencyService.formatCurrency(value ?? 0, '1.2-2') || '—';
  }
}
